<script>
import ieBooking from '@/views/cargo/v0/Integrated/ieBooking'

export default {
  name: 'ICIEBooking',
  extends: ieBooking,
  props: {
    integratedLogisticsType: {
      type: String,
      default: 'IC' // 设置默认值
    }
  }
}
</script>
